import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";
import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { Button } from "@/components/ui/button/button";
import { ExternalLink } from "@/components/ui/button/external-link";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";
import { SelectField } from "@/components/ui/form/fields/select-field";

import type { SnackFormBaseModelMethodsType } from "../../../../model/usecase/use-create-snack-settings-form-model/methods";
import type { DesignSnackSettingsFormModel } from "../../../../model/usecase/use-create-snack-settings-form-model/type";

type Props = {
	snackSettingsViewModel: DesignSnackSettingsFormModel["ViewModel"];
	snackSettingsMethods: SnackFormBaseModelMethodsType;
};

export const IslandSnackSettings = ({ snackSettingsViewModel, snackSettingsMethods }: Props) => {
	return (
		<FeatureIslandMainWithBackGround islandTitle="スナック">
			<div>
				<ExternalLink
					href="https://chillnn.notion.site/e8d889578b934d4799d0f2c84f5e3f60"
					text="スナックの設定方法"
				/>
			</div>

			<QuestionForMain
				required
				title="URL設定"
				guide=""
				inputChildren={
					<div className="space-y-4">
						<div className="flex flex-wrap items-center gap-x-2 sm:flex-nowrap">
							<p>https://</p>
							<InputTextField
								className="w-3/4 xl:w-1/2"
								value={snackSettingsViewModel.subDomain.value}
								errorMessage={snackSettingsViewModel.subDomain.error}
								handleChange={snackSettingsMethods.onSetDomainName}
							/>
							<p>.{snackSettingsViewModel.baseDomain}</p>
						</div>
						<Button
							type="button"
							variant={snackSettingsMethods.canCopySnackPageURL ? "outline" : "disabled"}
							size="sm"
							onClick={snackSettingsMethods.copySnackPageURL}
						>
							URLをコピー
						</Button>
					</div>
				}
			/>
			<QuestionForMain
				required={false}
				title="Google Analytics"
				guide=""
				inputChildren={
					<InputTextField
						label="GTMのコンテナID"
						value={snackSettingsViewModel.gtmID?.value}
						handleChange={snackSettingsMethods.onSetGtmID}
						errorMessage={snackSettingsViewModel.gtmID?.error}
					/>
				}
			/>
			<QuestionForMain
				required={false}
				title="TOPページに表示するスナック"
				guide="通常は設定不要です。未設定の場合、TOPページにはレイアウト設定の内容が表示されます。スナックを選択すると、TOPページにそのスナックが表示されます。TOPページに設定中のスナックは、削除・非公開にできません。"
				inputChildren={
					<SelectField
						value={snackSettingsMethods.topPageSnackValue}
						options={snackSettingsMethods.topPageSnackOptions}
						handleValueChange={snackSettingsMethods.onSetTopPageSnackValue}
					/>
				}
			/>
		</FeatureIslandMainWithBackGround>
	);
};

IslandSnackSettings.displayName = "IslandSnackSettings";
